export default __webpack_public_path__ + "static/media/tab2.f2fa5209.svg";